import { render, staticRenderFns } from "./FreehandIcon.vue?vue&type=template&id=da6699b0&"
import script from "./FreehandIcon.vue?vue&type=script&lang=js&"
export * from "./FreehandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports